import React, { useState } from "react";
import "../style/components/dashboard/personlisation/Quiz.scss";
import { ReactComponent as EditIcon } from "../assets/svg/circum_edit.svg";
import { ReactComponent as DotsIcon } from "../assets/svg/three-dots.svg";
import { ReactComponent as LinkIcon } from "../assets/svg/bitcoin-icons_link-outline.svg";
import { ReactComponent as ExpandIcon } from "../assets/svg/system-uicons_expand.svg";

// Initial tree structure
const initialTree = {
  id: "root",
  question: "",
  environmentURL: "",
  hideButton: true,
  disableQuestionButton: false,
  disableEnvButton: false,
  addEnvNode: false,
  children: [],
};

const TreeNode = ({ node, onUpdate, onDelete, parentHasMultipleChildren }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isButtonVisible, setButtonVisible] = useState(false);
  const [newQuestion, setNewQuestion] = useState(node.question);
  const [envURL, setEnvURL] = useState(node.environmentURL || "");
  const [isSelectingURL, setIsSelectingURL] = useState(false);

  // Handle adding child nodes
  const handleAddChild = () => {
    setButtonVisible(false);
    if (!node.hasAddedAnswer) {
      // First time: add two child branches
      onUpdate(node.id, {
        children: [
          ...node.children,
          {
            id: `${node.id}-${node.children.length + 1}`,
            question: "",
            environmentURL: "",
            children: [],
            hideButton: false,
            addEnvNode: false,
          },
          {
            id: `${node.id}-${node.children.length + 2}`,
            question: "",
            environmentURL: "",
            children: [],
            hideButton: false,
            addEnvNode: false,
          },
        ],
        hasAddedAnswer: true, // Set the flag
      });
    } else {
      // Subsequent times: add only one child branch
      onUpdate(node.id, {
        children: [
          ...node.children,
          {
            id: `${node.id}-${node.children.length + 1}`,
            question: "",
            environmentURL: "",
            children: [],
            hideButton: false,
          },
        ],
      });
    }
  };

  //handle Add Question
  const handleAddQuestion = () => {
    setButtonVisible(false);
    onUpdate(node.id, {
      disableQuestionButton: true,
      disableEnvButton: true,
      children: [
        ...node.children,
        {
          id: `${node.id}-${node.children.length + 1}`,
          question: "",
          environmentURL: "",
          disableQuestionButton: false,
          children: [],
          hideButton: true,
          addEnvNode: false,
        },
      ],
      hasAddedAnswer: true, // Set the flag
    });
  };

  const handleAddEnv = () => {
    setButtonVisible(false);
    onUpdate(node.id, {
      disableEnvButton: true,
      disableQuestionButton: true,
      children: [
        ...node.children,
        {
          id: `${node.id}-${node.children.length + 1}`,
          question: "",
          addEnvNode: true,
          disableQuestionButton: false,
          disableEnvButton: false,
          children: [],
          hideButton: true,
          environmentURL: "",
        },
      ],
    });
  };

  // Handle adding environment URL
  const handleAddEnvURL = () => {
    setIsSelectingURL(false);
    onUpdate(node.id, { environmentURL: envURL });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
      }}
    >
      <div
        className="node"
        style={{ width: "max-content", margin: "10px", padding: "10px", minWidth: '125px' }}
      >
        <div >
          {
            <>
              {node.addEnvNode ? (
                <button 
                onClick={() => setIsSelectingURL(prev => !prev)}
                className="text-button">
                  {node.environmentURL.length
                    ? <><LinkIcon/> {node.environmentURL} </>
                    : "Add Enviroment URL"}
                </button>
              ) : (
                <button className="text-button" onClick={() => setIsEditing(true)}>
                  {node.question.trim().length > 0 ? (
                    <>
                      {node.question}{" "}
                      <DotsIcon
                        className="dots"
                        onClick={(e) => {
                          e.stopPropagation();
                          setButtonVisible((prev) => !prev);
                        }}
                      />
                    </>
                  ) : node.hideButton ? (
                    <>
                      <EditIcon /> Add Question
                    </>
                  ) : (
                    <>
                      <EditIcon /> Add Answer
                    </>
                  )}
                </button>
              )}
            </>
          }
          {/* Question Text */}
          {isEditing && (
            <div className="set-title">
              <input
                value={newQuestion}
                onChange={(e) => setNewQuestion(e.target.value)}
              />
              <button
                onClick={() => {
                  onUpdate(node.id, { question: newQuestion });
                  setIsEditing(false);
                }}
              >
                Save
              </button>
            </div>
          )}

          {node.addEnvNode && isSelectingURL ? (
            <div className="select-env">
              <p>Add ENviroment URL</p>
              <select
      value={envURL}
      onChange={(e) => setEnvURL(e.target.value)}
    >
      <option value="" disabled>
        Select an option
      </option>
      <option value="https://example.com/env1">Environment 1</option>
      <option value="https://example.com/env2">Environment 2</option>
      <option value="https://example.com/env3">Environment 3</option>
    </select>
    <button onClick={handleAddEnvURL}>Save</button>
            </div>
          ) : (
            isButtonVisible && (
              <div className="node-action-button">
                {node.hideButton ? (
                  <button onClick={handleAddChild}>Add Answer</button>
                ) : (
                  <>
                    <button
                      onClick={handleAddQuestion}
                      disabled={node.disableQuestionButton}
                    >
                      Add Question
                    </button>
                    <button
                      onClick={handleAddEnv}
                      disabled={node.disableEnvButton}
                    >
                      Add Enviroment
                    </button>
                  </>
                )}

                {!node.hideButton ? (
                  parentHasMultipleChildren && (
                    <button
                      onClick={() => {
                        setButtonVisible(false);
                        onDelete(node.id);
                      }}
                    >
                      Delete
                    </button>
                  )
                ) : (
                  <button
                    onClick={() => {
                      setButtonVisible(false);
                      onDelete(node.id);
                    }}
                  >
                    Delete
                  </button>
                )}
              </div>
            )
          )}
        </div>
      </div>

      {/* Recursive Children */}
      <div
        className={`${node.hideButton ? "child" : "child2"}`}
        style={{ display: "flex" }}
      >
        {node.children &&
          node.children.map((child) => (
            <TreeNode
              key={child.id}
              node={child}
              onUpdate={onUpdate}
              onDelete={onDelete}
              parentHasMultipleChildren={node.children.length >= 3}
            />
          ))}
      </div>
    </div>
  );
};

const Test = () => {
  const [tree, setTree] = useState(initialTree);
  const [fullScreen, setFullScreen] = useState(false);

  const updateNode = (id, updates, currentNode = tree) => {
    if (currentNode.id === id) {
      return { ...currentNode, ...updates };
    }

    return {
      ...currentNode,
      children: currentNode.children.map((child) =>
        updateNode(id, updates, child)
      ),
    };
  };

  const deleteNode = (id, currentNode = tree, parentNode = null) => {
    if (currentNode.id === id) {
      if (parentNode) {
        parentNode.disableQuestionButton = false;
        parentNode.disableEnvButton = false;
      }
      return null;
    }

    return {
      ...currentNode,
      children: currentNode.children
        .map((child) => deleteNode(id, child, currentNode))
        .filter((child) => child !== null),
    };
  };

  const handleUpdate = (id, updates) => {
    setTree((prevTree) => updateNode(id, updates, prevTree));
  };

  const handleDelete = (id) => {
    if (id === "root") {
      setTree(initialTree);
    } else {
      setTree((prevTree) => deleteNode(id, prevTree));
    }
  };

  return (
    <div className={`screen ${fullScreen ? 'fullscreen' : ''}`} >
      <div className="expand" onClick={() => setFullScreen(prev =>!prev)}>
        <ExpandIcon/>
      </div>
      <div className="bcd">
        <TreeNode node={tree} onUpdate={handleUpdate} onDelete={handleDelete} />
        <button onClick={() => console.log(tree)}>display Json</button>
      </div>
    </div>
  );
};

export default Test;
